import apiClient from './api';

export interface SwapRequestData {
    id: string;
    requesterId: string;
    shiftId: string;
    targetUserId?: string;
    swapType: 'COVER' | 'SWAP';
    targetShiftId?: string;
    status: string;
    adminNotes?: string;
    shift: {
        id: string;
        startTime: string;
        endTime: string;
        type?: string;
        location?: string;
        userId: string;
        user?: { id: string; name: string; email?: string };
        originalUser?: { id: string; name: string; email?: string } | null;
    };
    targetShift?: {
        id: string;
        startTime: string;
        endTime: string;
        type?: string;
        location?: string;
        userId: string;
        user?: { id: string; name: string; email?: string };
        originalUser?: { id: string; name: string; email?: string } | null;
    };
    requester: { id?: string; name: string; email?: string };
    targetUser?: { id?: string; name: string; email?: string };
    reviewedBy?: { id: string; name: string; email?: string } | null;
    reviewedAt?: string;
    reviewedByRole?: string;
    createdAt?: string;
}

export const createSwapRequest = async (shiftId: string, targetUserId?: string, swapType: 'COVER' | 'SWAP' = 'COVER', targetShiftId?: string) => {
    const response = await apiClient.post('/swaps', { shiftId, targetUserId, swapType, targetShiftId });
    return response.data;
};

export const getSwaps = async (type: 'market' | 'mine' | 'all' = 'mine') => {
    const response = await apiClient.get(`/swaps?type=${type}`);
    return response.data;
};

export const acceptSwap = async (id: string) => {
    const response = await apiClient.patch(`/swaps/${id}/accept`, {});
    return response.data;
};

export const updateSwapStatus = async (id: string, status: string, adminNotes?: string) => {
    const response = await apiClient.patch(`/swaps/${id}/status`, { status, adminNotes });
    return response.data;
};

export const deleteSwapRequest = async (id: string) => {
    const response = await apiClient.delete(`/swaps/${id}`);
    return response.data;
};

export const withdrawSwap = async (id: string) => {
    const response = await apiClient.patch(`/swaps/${id}/withdraw`, {});
    return response.data;
};
